import React, { Component } from 'react';
import Notifications from '../Notifications';
import Polls from '../Polls';
import Surveys from '../Surveys';
import styled from 'styled-components';
//import cssVariables from '../../../../assets/css/variables.config.css';

const StyledOverlay = styled.div`
    .sf-back-to-chat{
        background-image : none;
        background-color : ${props => props.data.primaryColor}
    }
`


interface Props {
    toggleOverlay,
    isOverlayVisible: boolean,
    data
}

class ChatOverlay extends Component<Props,null> {
    trackBannerOutboundLink(ev) {
        console.log(ev)
    }

    //Everething was well slow
    // Just use react profiler before/after commenting the below block
    // Please use botID = 136 (@ prod) for better comparisions 
    shouldComponentUpdate(nextProps,nextState){
        if(nextProps.isOverlayVisible != this.props.isOverlayVisible)
            return true
        else 
            return false
    }

    render() {
        return (
            <StyledOverlay {...this.props} >
            <div className="sf-offers-roll" style={{ display: this.props.isOverlayVisible ? "block" : "none" }}>
                <div className="sf-offers-pane">
                    <span>
                        <b style={{ marginLeft: "0px" }}>Notifications </b>
                        <Notifications />
                        <br />
                        <b style={{ marginLeft: "0px" }}>Polls </b>
                        <Polls />
                        <br />
                        <b style={{ marginLeft: "0px" }}>Surveys </b>
                        <Surveys />


                    </span>
                </div>
                <div className="sf-back-to-chat-outer">
                    <button onClick={this.props.toggleOverlay} className="sf-back-to-chat">
                        Back to Chat
                    </button>
                </div>
            </div>
            </StyledOverlay>
        );
    }
}

export default ChatOverlay;